import UpsellVariantB from './UpsellForm/UpsellForm';

export default UpsellVariantB;
